export interface WeatherData {
  hourly: {
    time: string[];
    cloud_cover: number[];
    cloud_cover_low: number[];
    cloud_cover_mid: number[];
    cloud_cover_high: number[];
    relative_humidity_2m: number[];
    visibility: number[];
    wind_speed_10m: number[];
    wind_direction_10m: number[];
    surface_pressure: number[];
  };
}

export function calculateGoldenBlueHours(sunriseTime: string, sunsetTime: string) {
  const sunrise = new Date(sunriseTime);
  const sunset = new Date(sunsetTime);

  // Golden hour: ~1 hour after sunrise and ~1 hour before sunset
  // Blue hour: ~30 min before sunrise and ~30 min after sunset
  
  const goldenHourMorningStart = new Date(sunrise.getTime());
  const goldenHourMorningEnd = new Date(sunrise.getTime() + 60 * 60 * 1000); // +1 hour

  const goldenHourEveningStart = new Date(sunset.getTime() - 60 * 60 * 1000); // -1 hour
  const goldenHourEveningEnd = new Date(sunset.getTime());

  const blueHourMorningStart = new Date(sunrise.getTime() - 30 * 60 * 1000); // -30 min
  const blueHourMorningEnd = new Date(sunrise.getTime());

  const blueHourEveningStart = new Date(sunset.getTime());
  const blueHourEveningEnd = new Date(sunset.getTime() + 30 * 60 * 1000); // +30 min

  return {
    goldenHourMorningStart: goldenHourMorningStart.toISOString(),
    goldenHourMorningEnd: goldenHourMorningEnd.toISOString(),
    goldenHourEveningStart: goldenHourEveningStart.toISOString(),
    goldenHourEveningEnd: goldenHourEveningEnd.toISOString(),
    blueHourMorningStart: blueHourMorningStart.toISOString(),
    blueHourMorningEnd: blueHourMorningEnd.toISOString(),
    blueHourEveningStart: blueHourEveningStart.toISOString(),
    blueHourEveningEnd: blueHourEveningEnd.toISOString(),
  };
}

export function getWeatherAtTime(weatherData: WeatherData, targetTime: string): {
  cloudCoverTotal: number;
  cloudCoverLow: number;
  cloudCoverMid: number;
  cloudCoverHigh: number;
  humidity: number;
  visibility: number;
  windSpeed: number;
  windDirection: number;
  pressure: number;
} {
  if (!weatherData?.hourly?.time?.length) {
    return {
      cloudCoverTotal: 0,
      cloudCoverLow: 0,
      cloudCoverMid: 0,
      cloudCoverHigh: 0,
      humidity: 0,
      visibility: 0,
      windSpeed: 0,
      windDirection: 0,
      pressure: 1013,
    };
  }

  const targetDate = new Date(targetTime);
  const hourlyTimes = weatherData.hourly.time.map(t => new Date(t));
  
  // Find the closest hour
  let closestIndex = 0;
  let minDiff = Math.abs(hourlyTimes[0]!.getTime() - targetDate.getTime());
  
  for (let i = 1; i < hourlyTimes.length; i++) {
    const diff = Math.abs(hourlyTimes[i]!.getTime() - targetDate.getTime());
    if (diff < minDiff) {
      minDiff = diff;
      closestIndex = i;
    }
  }

  return {
    cloudCoverTotal: Math.round(weatherData.hourly.cloud_cover[closestIndex] ?? 0),
    cloudCoverLow: Math.round(weatherData.hourly.cloud_cover_low[closestIndex] ?? 0),
    cloudCoverMid: Math.round(weatherData.hourly.cloud_cover_mid[closestIndex] ?? 0),
    cloudCoverHigh: Math.round(weatherData.hourly.cloud_cover_high[closestIndex] ?? 0),
    humidity: Math.round(weatherData.hourly.relative_humidity_2m[closestIndex] ?? 0),
    visibility: Math.round(weatherData.hourly.visibility[closestIndex] ?? 0),
    windSpeed: Math.round(weatherData.hourly.wind_speed_10m[closestIndex] ?? 0),
    windDirection: Math.round(weatherData.hourly.wind_direction_10m[closestIndex] ?? 0),
    pressure: Math.round(weatherData.hourly.surface_pressure[closestIndex] ?? 0),
  };
}
